/**
 * Fills the {placeholders} of a translated string: interpolate('{count} ta kurs', { count: 3 }).
 *
 * One pass over the text, so a value is inserted as it is: a course called "Save $$" or
 * "{count}" is never read as a replacement pattern or filled in a second time. A placeholder
 * that has no value is left as written.
 */
export function interpolate(text, vars) {
  if (typeof text !== 'string' || !vars) return text;
  return text.replace(/\{([A-Za-z0-9_]+)\}/g, (match, name) => (
    Object.prototype.hasOwnProperty.call(vars, name) ? String(vars[name]) : match
  ));
}

export default interpolate;
